export function useProduct() {
    function setOptionValueId(id) {
        return String('$' + id);
    }

    // remove the prefix '$' from the id and return number
    function getOptionValueId(id) {
        if (typeof id === 'number') {
            return id;
        }
        if (typeof id === 'string' && id.startsWith('$')) {
            return Number(id.substring(1));
        }
        return Number(id);
    }
    
    return {
        setOptionValueId,
        getOptionValueId
    };
}